import { isEmpty, isNil } from "ramda";

export default function exists(param) {
  return !isNil(param) && !isEmpty(param);
}